<div class="touareg-control-dialog" mat-dialog-content>
  <app-touareg-control (close)="close()"></app-touareg-control>
</div>
